"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const EpicToaster = ({ theme, ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={theme}
      className="epic-toaster"
      toastOptions={{
        className: "epic-toast",
        style: {
          marginTop: "1rem",
        },

        classNames: {
          title: "epic-toast-title",
          description: "epic-toast-description",
          actionButton: "epic-toast-action-button",
          closeButton: "epic-toast-cancel-button",
        },
      }}
      {...props}
    />
  );
};

export { EpicToaster };
